<template lang="pug">
  .wrap
    h1 Créditos
    ul.credits
      li(v-for="(credit, index) in credits")
        .col1
          span {{credit.role}}:
        .col2
          .strong(v-for="(person, index) in credit.persons") {{person}}

</template>
<script>
export default {
  props: {
    credits: Array
  }
}
</script>
<style lang="scss" scoped>
  .wrap{
    text-align: center;
    padding: 2rem 0;
  }
  .credits{
    li{
      list-style: none;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 1rem;
      padding-bottom: 1rem;
      .col1{
        text-align: right;
      }
      .col2{
        text-align: left;
      }
    }
  }
  .col1{

  }
</style>


